module.exports = __webpack_public_path__ + "static/media/icono_completo.77f9e205.svg";